import { List, Record } from 'immutable';
import { THREAD_REMOVAL_TYPE } from './threadRemovalKeyPaths';
import { ASSIGNMENT } from './threadRemovalTypes';
const AssignmentRemoval = Record({
  [THREAD_REMOVAL_TYPE]: ASSIGNMENT,
  assignee: null,
  audit: null,
  members: List()
}, 'AssignmentRemoval');
export default AssignmentRemoval;